import { takeEvery } from 'redux-saga/effects';
import { get } from 'lodash';
import { LOCATION_CHANGE } from '../../utils/redux/location-reducer';
import { COMMUNITIES, LOGIN, COMMUNITY_PREVIEW } from '../../constants/routes';
import { ACTIVE_COMMUNITY_ID } from '../../constants/storageKeys';

function* locationsSagaWorker(action) {
  const pathname = get(action, 'payload.pathname');
  const hasCommunity = pathname.includes(COMMUNITIES);
  const hasCommunityPrev = pathname.includes(COMMUNITY_PREVIEW);
  const hasLogin = pathname.includes(LOGIN);

  if (hasCommunity || hasCommunityPrev) {
    const communityId = pathname.replace(/\D/g, '');

    if (communityId) {
      yield window.storage.setItem(ACTIVE_COMMUNITY_ID, communityId);
      return;
    }
  }

  if (hasLogin) return;

  yield window.storage.removeItem(ACTIVE_COMMUNITY_ID);
}

export default function* locationsSaga() {
  yield takeEvery(LOCATION_CHANGE, locationsSagaWorker);
}



// WEBPACK FOOTER //
// ./src/redux/common/locationsSaga.js